import {NetworkAPIVersion, NetworkParamType} from './network.utils';

const storyParams = {
  title: [NetworkParamType.string],
  content: [NetworkParamType.string],
  collections: [NetworkParamType.array],
  tags: [NetworkParamType.array],
  assets: [NetworkParamType.array],
  places: [NetworkParamType.array],
  clans: [NetworkParamType.array],
  tree_persons: [NetworkParamType.array],
  sources: [NetworkParamType.array],
  mention_persons: [NetworkParamType.array],
  status: [NetworkParamType.string],
  is_public: [NetworkParamType.boolean],
  date_text: [NetworkParamType.number],
  author: [NetworkParamType.number],
};

const collectionParams = {
  cover_image: [NetworkParamType.file],
  data: [NetworkParamType.string],
};

const bulkCreateCompilationParams = {
  story_ids: [NetworkParamType.array],
  title: [NetworkParamType.string],
  description: [NetworkParamType.string],
  is_public: [NetworkParamType.boolean],
};

const bulkTagStoriesParams = {
  story_ids: [NetworkParamType.array],
  tags: [NetworkParamType.array],
};

const bulkPublishStoriesParams = {
  story_ids: [NetworkParamType.array],
};

const bulkAddStoriesToCompilationParams = {
  story_ids: [NetworkParamType.array],
  collection_id: [NetworkParamType.string],
};

export default {
  getFamilyWebSiteList: {
    url: 'familywebsite/?order_by=priority&order_by=-created_at',
    method: 'get',
    apiVersion: NetworkAPIVersion.v1_version,
    params: {
      order_by: [NetworkParamType.array],
      limit: [NetworkParamType.number],
      offset: [NetworkParamType.number],
      username: [NetworkParamType.string],
    },
    authorization: true,
    fws: true,
  },
  getFamilyWebSiteListByName: {
    url: 'familywebsite/get-by-name/',
    method: 'get',
    apiVersion: NetworkAPIVersion.v1_version,
    params: {
      username: [NetworkParamType.string],
      site_name: [NetworkParamType.string],
      keep_image_asset_id: [NetworkParamType.string],
      part: [NetworkParamType.array],
    },
    authorization: true,
    fws: true,
  },
  getMySites: {
    url: 'familywebsite/my-sites/',
    method: 'get',
    apiVersion: NetworkAPIVersion.v1_version,
    params: {
      context_tree_id: [NetworkParamType.string],
    },
  },
  getFamilyWebsiteParsePreview: {
    url: 'api/familywebsite-parse-preview/{siteId}/',
    method: 'get',
    apiVersion: NetworkAPIVersion.noVersion,
  },
  saveFamilyWebsiteParsePreview: {
    url: 'api/familywebsite-parse-preview/{siteId}/save/',
    method: 'post',
    apiVersion: NetworkAPIVersion.noVersion,
  },
  updateMySite: {
    url: 'familywebsite/{username}/',
    method: 'put',
    apiVersion: NetworkAPIVersion.v1_version,
    params: {
      is_public: [NetworkParamType.boolean],
    },
  },
  addMembers: {
    url: 'familywebsite/{username}/add-members/',
    apiVersion: NetworkAPIVersion.v1_version,
    method: 'post',
    params: {
      emails: [NetworkParamType.array],
    },
  },
  deleteMember: {
    url: 'familywebsite/{username}/delete-member/',
    apiVersion: NetworkAPIVersion.v1_version,
    method: 'post',
    params: {
      email: [NetworkParamType.string],
    },
  },
  searchStories: {
    url: 'api/stories/search/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
    autoCancel: true,
    params: {
      limit: [NetworkParamType.number],
      offset: [NetworkParamType.number],
      person_id: [NetworkParamType.string],
      person_ids: [NetworkParamType.string],
      clans: [NetworkParamType.string],
      operator: [NetworkParamType.string],
      context_tree_id: [NetworkParamType.string],
    },
  },
  searchStoriesSimple: {
    url: 'api/stories/{tree_id}/search/stories/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
    autoCancel: true,
    params: {
      query: [NetworkParamType.string],
      exclude_story_ids: [NetworkParamType.array],
    },
  },
  searchResearchContent: {
    url: 'api/research-content/search/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
    autoCancel: true,
    params: {
      type: [NetworkParamType.string],
      author_id: [NetworkParamType.string],
      query: [NetworkParamType.string],
      client: [NetworkParamType.string],
      research_client_id: [NetworkParamType.string],
      tags: [NetworkParamType.string],
      research_project_id: [NetworkParamType.string],
      clauses: [NetworkParamType.string],
      category: [NetworkParamType.string],
      note_type: [NetworkParamType.string],
      limit: [NetworkParamType.number],
      offset: [NetworkParamType.number],
    },
  },
  getResearchContentOptions: {
    url: 'api/research-content/options/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
    autoCancel: true,
    params: {
      projects_query: [NetworkParamType.string],
      project_limit: [NetworkParamType.number],
      tag_limit: [NetworkParamType.number],
    },
  },
  autocompleteResearchContentClients: {
    url: 'api/research-content/autocomplete-clients/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
    autoCancel: true,
    params: {
      query: [NetworkParamType.string],
      limit: [NetworkParamType.number],
    },
  },
  getStories: {
    url: 'api/stories/{tree_id}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
    autoCancel: true,
    params: {
      limit: [NetworkParamType.number],
      offset: [NetworkParamType.number],

      q: [NetworkParamType.string],
      collections: [NetworkParamType.string],
      exclude_collection: [NetworkParamType.string],
      sources: [NetworkParamType.string],
      places: [NetworkParamType.string],
      tags: [NetworkParamType.string],
      clans: [NetworkParamType.string],
      tree_persons: [NetworkParamType.string],
      mention_persons: [NetworkParamType.string],
      authors: [NetworkParamType.string],
      ownership: [NetworkParamType.string],
    },
  },
  forceGetStories: {
    url: 'api/stories/{tree_id}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
    params: {
      with_details: [NetworkParamType.string],
      collections: [NetworkParamType.string],
    },
  },
  getStoriesAutocomplete: {
    url: 'api/stories/{tree_id}/search/autocomplete/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
    autoCancel: true,
    params: {
      search: [NetworkParamType.string],
    },
  },
  createStory: {
    url: 'api/stories/{tree_id}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'post',
    params: storyParams,
  },
  updateStory: {
    url: 'api/stories/{tree_id}/{slug}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'patch',
    params: storyParams,
  },
  createStoryPin: {
    url: 'api/story-pins/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'post',
    params: {
      story_id: [NetworkParamType.string],
      collection_id: [NetworkParamType.string],
      tree_id: [NetworkParamType.string],
      order: [NetworkParamType.number],
    },
  },
  deleteStoryPin: {
    url: 'api/story-pins/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'delete',
    params: {
      story_id: [NetworkParamType.string],
      collection_id: [NetworkParamType.string],
      tree_id: [NetworkParamType.string],
      order: [NetworkParamType.number],
    },
  },
  getStory: {
    url: 'api/stories/{tree_id}/{slug}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
  },
  deleteStory: {
    url: 'api/stories/{tree_id}/{slug}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'delete',
  },
  getStoriesCollections: {
    url: 'api/story-collections/{tree_id}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
  },
  getStoriesCollection: {
    url: 'api/story-collections/{tree_id}/{slug}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
  },
  createStoriesCollection: {
    url: 'api/story-collections/{tree_id}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'post',
    params: collectionParams,
    multipart: true,
  },
  bulkCreateStoriesCompilation: {
    url: 'api/stories/{tree_id}/bulk/create-compilation/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'post',
    params: bulkCreateCompilationParams,
  },
  bulkTagStories: {
    url: 'api/stories/{tree_id}/bulk/tag/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'post',
    params: bulkTagStoriesParams,
  },
  bulkPublishStories: {
    url: 'api/stories/{tree_id}/bulk/publish/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'post',
    params: bulkPublishStoriesParams,
  },
  bulkAddStoriesToCompilation: {
    url: 'api/stories/{tree_id}/bulk/add-to-compilation/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'post',
    params: bulkAddStoriesToCompilationParams,
  },
  getStoriesCollectionPDF: {
    url: 'api/story-collections/pdf/{tree_id}/{slug}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
  },
  updateStoriesCollection: {
    url: 'api/story-collections/{tree_id}/{slug}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'patch',
    params: collectionParams,
    multipart: true,
  },
  deleteCompilation: {
    url: 'api/story-collections/{tree_id}/{slug}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'delete',
  },
  transcribeAsset: {
    url: 'api/stories/transcribe-asset/{assetId}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'post',
  },
  transcribeAssetStatus: {
    url: 'api/stories/transcribe-asset/{assetId}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
    params: {
      task_id: [NetworkParamType.string],
    },
  },
  translateAsset: {
    url: 'api/stories/translate-asset/{assetId}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
  },
  summariseAsset: {
    url: 'api/stories/summarise-asset/{assetId}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
  },
  getShare: {
    url: 'api/stories/share/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
    params: {
      story_id: [NetworkParamType.string],
      collection_id: [NetworkParamType.string],
    },
  },
  createShare: {
    url: 'api/stories/share/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'post',
    params: {
      story_id: [NetworkParamType.string],
      collection_id: [NetworkParamType.string],
      emails: [NetworkParamType.array],
    },
  },
  deleteShare: {
    url: 'api/stories/share/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'delete',
    params: {
      share_id: [NetworkParamType.string],
    },
  },
  getContentShares: {
    url: 'api/content-shares/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
  },
  createContentShare: {
    url: 'api/content-shares/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'post',
    allowArray: true,
    params: {
      shared_with_email: [NetworkParamType.string],
      share_everything: [NetworkParamType.boolean],
      story_id: [NetworkParamType.string],
      collection_id: [NetworkParamType.string],
      family_tree_id: [NetworkParamType.number],
      is_editor: [NetworkParamType.boolean],
    },
  },
  deleteContentShare: {
    url: 'api/content-shares/{id}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'delete',
    params: {
      id: [NetworkParamType.string],
    },
  },
  copyStory: {
    url: 'api/stories/copy/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'post',
    params: {
      story_id: [NetworkParamType.string],
      tree_id: [NetworkParamType.string],
    },
  },
  copyCompilation: {
    url: 'api/story-collections/copy/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'post',
    params: {
      collection_id: [NetworkParamType.string],
      tree_id: [NetworkParamType.string],
    },
  },
};
